import { render, staticRenderFns } from "./ResponseType3.vue?vue&type=template&id=b9834052&scoped=true"
import script from "./ResponseType3.vue?vue&type=script&lang=js"
export * from "./ResponseType3.vue?vue&type=script&lang=js"
import style0 from "./ResponseType3.vue?vue&type=style&index=0&id=b9834052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9834052",
  null
  
)

export default component.exports